import { api } from '@/lib/api'

export function deleteBeneficialOwner({ ownerId }: { ownerId: string }) {
  return api.delete<void>(`/v1/onboarding/beneficial-owners/${ownerId}`)
}
